export default {
    chillApiUrl: process.env.CHILL_API_URL,
    isMtDobson: process.env.IS_MT_DOBSON,
    isChchGondola: process.env.IS_CHCH_GONDOLA,
    profilePhotosUrl: process.env.PROFILE_PHOTOS_URL,
    passTypePhotosUrl: process.env.PASS_TYPE_PHOTOS_URL
}



// WEBPACK FOOTER //
// ./src/constants.js